import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { appRoutes } from 'app/app-routes';
import { searchParamTools } from 'common/tools/search-param-tools';
import { SearchParams } from 'common/types/SearchParams';
import {
  User,
  UserActionCode,
  useUsersAddSavedSearchMutation,
  useUsersRemoveSavedSearchMutation,
} from 'graphql/generated';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { cacheActions } from 'redux/cache.slice';

type Props = {
  value: boolean;
  toggleFn?: (value: boolean) => void;
  user?: User;
  itemId: string;
  saveSearchParams?: SearchParams;
  includeLabel?: boolean;
  deleteMode?: boolean;
};

const savedSearchColor = 'green';

const SavedSearchIcons = (props: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [addSavedSearch] = useUsersAddSavedSearchMutation();
  const [removeSavedSearch] = useUsersRemoveSavedSearchMutation();

  const fontSize = '24px';

  // const getName = () => {
  //   if (!props.user?.savedSearches?.length) return 'Saved Search 1';
  //   const words = props.user.savedSearches[props.user.savedSearches.length - 1].name.split(' ');
  //   return `Saved Search ${(+words[words.length - 1] + 1).toString()}`;
  // };
  const setSavedSearch = async () => {
    if (!props.user) {
      dispatch(cacheActions.loginNavigate(true));
      navigate(appRoutes.login);
      return;
    }
    if (!props.value) {
      if (!props.saveSearchParams) throw new Error('missing searchParams');
      const { data } = await addSavedSearch({
        variables: {
          usersAddSavedSearchId: props.user!.id,
          name: searchParamTools.toFriendlyName(props.saveSearchParams),
          searchParams: searchParamTools.toSaveJson(props.saveSearchParams),
        },
      });
      if (data?.usersAddSavedSearch && data.usersAddSavedSearch.code === UserActionCode.success) {
        const { __typename, ...updatedUser } = data.usersAddSavedSearch.user!;
        dispatch(cacheActions.user(updatedUser));
        if (props.toggleFn) props.toggleFn(true);
      }
    } else {
      const { data } = await removeSavedSearch({
        variables: { userId: props.user!.id, itemId: props.itemId },
      });
      if (data?.usersRemoveSavedSearch && data.usersRemoveSavedSearch.code === UserActionCode.success) {
        const { __typename, ...updatedUser } = data.usersRemoveSavedSearch.user!;
        dispatch(cacheActions.user(updatedUser));
        if (props.toggleFn) props.toggleFn(false);
      }
    }
  };

  return (
    <>
      {(!props.deleteMode || props.value) && (
        <IconButton
          color="primary"
          sx={{ padding: 0 }}
          aria-label="savedSearch"
          component="span"
          onClick={() => setSavedSearch()}
        >
          {props.value ? (
            <>
              {props.deleteMode ? (
                <DeleteForeverIcon sx={{ fontSize }} />
              ) : (
                <>
                  <SavedSearchIcon sx={{ fontSize, color: savedSearchColor }} />
                  {props.includeLabel && (
                    <Typography color="primary" sx={{ paddingLeft: '2px' }} fontSize={13} variant="body1">
                      Search Saved
                    </Typography>
                  )}
                </>
              )}
            </>
          ) : (
            <>
              <SearchIcon sx={{ fontSize }} />
              {props.includeLabel && (
                <Typography color="primary" sx={{ paddingLeft: '2px' }} fontSize={13} variant="body1">
                  Save Search
                </Typography>
              )}
            </>
          )}
        </IconButton>
      )}
    </>
  );
};

export default SavedSearchIcons;
